module.exports = __webpack_public_path__ + "assets/media/evening.f51279d9.mp3";